import { queryOptions } from '@tanstack/react-query'
import { apiGet, apiPost } from './client'
import type { CronAnswer } from './cronAnswer'

/**
 * Settings → Easeedesk → Escalation settings.
 *
 * Perechile vechi: `settings/easeedesk/escalation_settings`,
 * `get_escalation_types_list`, `get_escalation_general_settings`,
 * `save_ticket_escalation_types`, `save_ticket_escalation_settings`,
 * `rebuild_remove_escalation_configuration`.
 *
 * `apiGet` / `apiPost` pun ELE `/api/v2` in fata caii.
 */

export interface EscalationType {
  escalation_type: number
  type_name: string
  escalation_color: string
  checked: number
}

export interface EscalationTicketType {
  ID: number
  type_name: string
  short_name: string
  color_identifier: string
  checked: number
}

export interface EscalationGeneral {
  ticket_types: EscalationTicketType[]
  settings: { pending_time: number; pending_time_status: number }
}

export function escalationShellQuery() {
  return queryOptions({
    queryKey: ['settings', 'easeedesk', 'escalation_settings'],
    queryFn: () => apiGet<{ title: string; moduleUrl: string }>('/settings/easeedesk/escalation_settings'),
  })
}

export function escalationTypesQuery() {
  return queryOptions({
    queryKey: ['settings', 'easeedesk', 'escalation_settings', 'types'],
    queryFn: () => apiGet<{ types: EscalationType[] }>('/settings/easeedesk/escalation_settings/types'),
  })
}

export function escalationGeneralQuery() {
  return queryOptions({
    queryKey: ['settings', 'easeedesk', 'escalation_settings', 'general'],
    queryFn: () => apiGet<EscalationGeneral>('/settings/easeedesk/escalation_settings/general'),
  })
}

export function saveEscalationTypes(types: EscalationType[]) {
  return apiPost<{ ok?: boolean; saved?: number }>('/settings/easeedesk/escalation_settings/types', {
    types: types.map((t) => ({
      id: t.escalation_type,
      color: t.escalation_color,
      status: t.checked === 1 ? 'on' : 'off',
    })),
  })
}

export function saveEscalationGeneral(
  ticketTypes: EscalationTicketType[],
  pending_time: number,
  pending_time_status: boolean,
) {
  return apiPost<{ ok?: boolean; saved?: number }>('/settings/easeedesk/escalation_settings/general', {
    ticket_types: ticketTypes.map((t) => ({ id: t.ID, status: t.checked === 1 ? 'on' : 'off' })),
    pending_time,
    pending_time_status: pending_time_status ? 'on' : 'off',
  })
}

export function rebuildEscalationCron() {
  return apiPost<CronAnswer>('/settings/easeedesk/escalation_settings/rebuild_cron', {})
}
